module.exports = __webpack_public_path__ + "img/pharm1.98df3309.jpeg";